export const SIDEBAR_BADGE_REFRESH = "admin-sidebar-badges:refresh";
export const SIDEBAR_BADGE_ADJUST = "admin-sidebar-badges:adjust";

export const refreshSidebarBadges = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SIDEBAR_BADGE_REFRESH));
};

export const adjustSidebarBadge = (key, delta) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SIDEBAR_BADGE_ADJUST, { detail: { key, delta } }));
};
